import React, { useState, useEffect, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import Cookies from 'js-cookie';
import axios from "axios";
import { url } from "../../../../../../../../../App";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import "./Deviation.css"
import PreviewModal from "../../../../../../../../Loan/ViewLoanDetails/Components/PreviewModal";
import { IoMdDownload } from "react-icons/io";
import Tooltip from "@mui/material/Tooltip";
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import {useParams } from "react-router-dom";
import { useBorrowerContext } from "../../../../../../store/borrower-details";

const fixedData = [
    { parameter: "Documents", deviationFixed: "Waiver of any document required as per policy (Not property related)" },
    { parameter: "Banking", deviationFixed: "Banking Account less than 6 or 12 months old or Repayment from co-applicant’s account (As per product’s policy norms)" },
    { parameter: "Overdue in loans", deviationFixed: "Referred / Negative / Waiver" },
    { parameter: "RCU Sampling", deviationFixed: "Referred / Failed / Fraud / Negative" },
    { parameter: "ECS/Inward Cheque bounces", deviationFixed: "> 3 Bounces in last six months (As per product’s policy norms)" },
    { parameter: "Written Off, Sub.Std, SMA or willful default", deviationFixed: "< 36 or upto 24 months (As per product’s policy norms)" },
    { parameter: "TVR", deviationFixed: "Referred / Negative / Waiver" },
    { parameter: "Personal Discussion", deviationFixed: "Negative-Applicable for escalation cases" },
    { parameter: "RTR", deviationFixed: "Last 12 months PTR-poor track record . PTR means payment of EMIs >30 DPD" },
    { parameter: "RTR", deviationFixed: "Last 12 months ATR - (Average track record). ATR means payment of EMIs within the same month" },
    { parameter: "Age Norms not met (if Income is considered)", deviationFixed: "Aged > 60 Years at the end of loan tenor (As per product's policy norms)" },
    { parameter: "FOIR", deviationFixed: "Up to 5% additional" },
    { parameter: "FOIR", deviationFixed: "> 5% additional" },
    { parameter: "Business Stability", deviationFixed: "upto 1 year" },
    { parameter: "Business Stability", deviationFixed: "< 2 year" },
    { parameter: "Geo-Limit", deviationFixed: "Geo limit (> 50 Kms from sourcing branch)" },
    { parameter: "Income ownership Norm", deviationFixed: "Not as per Norm" },
    { parameter: "Negative / Caution profile", deviationFixed: "" },
    { parameter: "End Use", deviationFixed: "Other than allowed by policy" },
    { parameter: "CIBIL Score", deviationFixed: "Below 650 (As per product's policy norms)" },
    { parameter: "considered is > 60% of business income", deviationFixed: "" },
    { parameter: "Deal Structure", deviationFixed: "if Female not part of the agreement" },
    { parameter: "Web check", deviationFixed: "Negative" },
    { parameter: "Internal dedupe", deviationFixed: "Negative / Waiver" },
    { parameter: "Negative Area / Caution Area", deviationFixed: "" },
    { parameter: "Restricted Community", deviationFixed: "" },
    { parameter: "Cattle Insurance", deviationFixed: "Insurance Coverage Tenure is lower than the approved loan tenure" },
    { parameter: "Life Insurance", deviationFixed: "Sum Assured is lower than the sanctioned loan amount/ Insurance Tenure is lower than the approved loan tenure" },
];

const Deviation = () => {
    const { loanid } = useParams();
    const loanId = loanid;
    const [open, setOpen] = React.useState(false);
    const token = Cookies.get('Token');
    const email = Cookies.get('Email');
    const [previewModal, setPreviewModal] = useState(false);
    const [base64Image, setBase64Image] = useState("");
    const [docType, setDocType] = useState("");
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [editingRowIndex, setEditingRowIndex] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [visible, setvisible] = useState(false);
    const [addDeviation, setAddDeviation] = useState(false);
    const [editDeviation, setEditDeviation] = useState(false);
    const { borrowerData } = useBorrowerContext();
    const fetchLoanDetails = borrowerData.loan;
    const foundLoan = fetchLoanDetails.find((item) => item.loan_id === loanId);
    const [isDisbursed, setIsDisbursed] = useState(false);

  useEffect(() => {
    if (loanId) {
      setIsDisbursed(foundLoan?.loan_status === "DISBURSED");
    }
    //eslint-disable-next-line
  }, [foundLoan]);


    const fileInputRefs = useRef([]);
    const [tableData, setTableData] = useState(
        fixedData.map((row) => ({
            ...row,
            deviationData: "",
            acmRcm: "",
            zcmCredHead: "",
            ceo: "",
            deviationRemarks: "",
            mitigate: "",
            deviationType: "",
            deviationBase64: "",
        }))
    );

    useEffect(() => {
        if (email === "rupesh.bishnoi@credin.in") {
            setvisible(true);
        } else {
            axios
                .post(url + "/user/getsingle", {
                    token: token,
                    email: email,
                    useremail: email
                })
                .then((res) => {
                    setAddDeviation(res.data[0]?.permission.add_deviation_cam)
                    setEditDeviation(res.data[0]?.permission.edit_deviation_cam)
                })
                .catch((err) => {
                    console.log(err);
                })
        };
    }, [email, token]);

    useEffect(() => {
        if (!loanId) return;
        const fetchExpenses = async () => {
            setOpen(true);
            try {
                const response = await axios.post(url + '/cam/get/deviation', {
                    token,
                    email,
                    loanId
                });

                if (response.data.auth) {
                    const fetchedExpenses = response.data.deviation;

                    if (fetchedExpenses && fetchedExpenses.length > 0) {
                        setTableData(fetchedExpenses);
                        setIsSubmitted(true);
                        setEditingRowIndex(null);
                    } else {
                        // If no data in DB, then show one empty row
                        const emptyData = fixedData.map((row) => ({
                            ...row,
                            deviationData: "",
                            acmRcm: "",
                            zcmCredHead: "",
                            ceo: "",
                            deviationRemarks: "",
                            mitigate: "",
                        }));
                        setTableData(emptyData);
                        setIsSubmitted(false);
                    }
                }
                else {
                    const emptyData = fixedData.map((row) => ({
                        ...row,
                        deviationData: "",
                        acmRcm: "",
                        zcmCredHead: "",
                        ceo: "",
                        deviationRemarks: "",
                        mitigate: "",
                    }));
                    setTableData(emptyData);
                    setIsSubmitted(false);
                }
            } catch (err) {
                console.error('Error fetching expenses:', err);
            } finally {
                setOpen(false);
            }
        };

        fetchExpenses();
    }, [loanId, email, token]);

    const handleDropdownChange = (index, field, value) => {
        // console.log(index)
        // console.log(field)
        // console.log(value)
        const updated = [...tableData];
        updated[index][field] = value;
        setTableData(updated);
    };

    const handleSubmit = async () => {
        setOpen(true);
        try {
            const response = await axios.post(url + '/cam/add/deviation', {
                token,
                email,
                loanId: loanId,
                deviation_matrix: tableData,
            });
            if (response.data.auth) {
                setTableData(response.data.data);
                setIsSubmitted(true);
                setEditingRowIndex(null);
                setIsEditMode(false);
                toast.success(response.data.message)
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error("Error fetching CAM data:", error);
        } finally {
            setOpen(false);
        }
    };

    const handleFileUpload = (index, event) => {
        const files = event.target.files;
        if (!files || files.length === 0) {
            return;
        }

        const file = files[0];
        const fileExtension = file.name.split(".").pop().toLowerCase();

        const allowedFormats = ["pdf"];
        if (!allowedFormats.includes(fileExtension)) {
            toast.error("Please upload in PDF format only.");
            return;
        }

        const reader = new FileReader();
        reader.onload = () => {
            const base64string = reader.result.split(",")[1];

            setTableData((prevState) =>
                prevState.map((row, i) =>
                    i === index
                        ? {
                            ...row,
                            deviationType: fileExtension,
                            deviationBase64: base64string,
                        }
                        : row
                )
            );

            toast.success(`Document uploaded successfully`);
        };
        reader.readAsDataURL(file);
    };

    const handleViewImage = async (key, format) => {
        // console.log(key)
        // console.log(format)
        setOpen(true);
        try {
            const { data } = await axios.post(url + "/cam/view/document", {
                key: key,
                token: Cookies.get("Token"),
                email: Cookies.get("Email"),
            })
            if (data.auth) {
                setOpen(false);
                setPreviewModal(true)
                setBase64Image(data.base64);
                setDocType(format)
            }
        } catch (error) {
            setOpen(false);
            console.log(error)
        }
    };

    const handleClosePreview = () => {
        setPreviewModal(false);
        setBase64Image("")
    };

    const downloadFileHandler = async (key, format) => {
        setOpen(true);
        try {
            const { data } = await axios.post(url + "/cam/view/document", {
                key: key,
                token: Cookies.get("Token"),
                email: Cookies.get("Email"),
            });

            if (data.auth) {
                setOpen(false);
                // console.log(data, "data of base64");
                downloadFile(format, data.base64);
            }
        } catch (error) {
            setOpen(false);
            console.log(error);
        }
    };

    const downloadFile = (format, base64) => {
        let mimeType;
        if (format.toLowerCase() === "pdf") {
            mimeType = "application/pdf";
        }
        const linkSource = `data:${mimeType};base64,${base64}`;
        const downloadLink = document.createElement("a");
        const fileName = `Deviation_Doc.${format}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    return (
        <div>
            <hr className="hori-line" />
            <div className="deviation-form">
                {loanId && (
                    <div className="deviation-content">
                        <h3 style={{ textAlign: "center" }}>Deviation Matrix</h3>
                        <div className="deviation-scroll-wrapper">
                            <table className="deviation-table" border="1" cellPadding="5">
                                <thead>
                                    <tr style={{ backgroundColor: '#cfe2f3' }}>
                                        <th>S.No</th>
                                        <th>Parameter</th>
                                        <th>Deviation</th>
                                        <th>Deviation</th>
                                        <th>ACM/RCM</th>
                                        <th>ZCM/Credit Head</th>
                                        <th>CEO</th>
                                        <th>Deviation Remarks</th>
                                        <th>Mitigate</th>
                                        <th>Action</th>
                                        <th>Upload/View/Download PDF</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableData?.map((row, i) => (
                                        <tr key={i}>
                                            <td>{i + 1}</td>
                                            <td>{row.parameter}</td>
                                            <td style={{ whiteSpace: "pre-line" }}>{row.deviationFixed}</td>

                                            {["deviationData", "acmRcm", "zcmCredHead", "ceo", "deviationRemarks", "mitigate"].map((field) => (
                                                <td key={field}>
                                                    <select
                                                        value={row[field]}
                                                        disabled={(isSubmitted && editingRowIndex !== i) || isDisbursed}
                                                        onChange={(e) => handleDropdownChange(i, field, e.target.value)}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="Approved">Approved</option>
                                                        <option value="NA">NA</option>
                                                    </select>
                                                </td>
                                            ))}
                                            <td>
                                                {(editDeviation || visible) && (
                                                    <Tooltip title="Edit Deviation">
                                                        <IconButton
                                                            onClick={() => {
                                                                setEditingRowIndex(i);
                                                                setIsEditMode(true);
                                                            }}
                                                            disabled={isDisbursed}
                                                        >
                                                            <EditIcon sx={{ color: '#034c9b' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </td>
                                            <td>
                                                <input
                                                    type="file"
                                                    ref={(el) => (fileInputRefs.current[i] = el)}
                                                    style={{ display: "none" }}
                                                    onChange={(e) => handleFileUpload(i, e)}
                                                    disabled={isDisbursed}
                                                />
                                                <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                                                    <button
                                                        className="deviation-btn"
                                                        onClick={() => fileInputRefs.current[i]?.click()}
                                                        disabled={isDisbursed}
                                                    >
                                                        Upload
                                                    </button>
                                                    {row.deviationPdfKey && row.deviationDocType && (
                                                        <button
                                                            className="deviation-btn"
                                                            onClick={() =>
                                                                handleViewImage(
                                                                    row.deviationPdfKey,
                                                                    row.deviationDocType
                                                                )
                                                            }
                                                        >
                                                            View
                                                        </button>
                                                    )}
                                                    {row.deviationPdfKey && row.deviationDocType && (
                                                        <Tooltip title="Download Document">
                                                            <p
                                                                onClick={() =>
                                                                    downloadFileHandler(
                                                                        row.deviationPdfKey,
                                                                        row.deviationDocType
                                                                    )
                                                                }
                                                            >
                                                                <IoMdDownload
                                                                    size={20}
                                                                    color="rgba(0, 94, 202, 0.952)"
                                                                    cursor={"pointer"}
                                                                />
                                                            </p>
                                                        </Tooltip>
                                                    )}
                                                </div>
                                            </td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        {(addDeviation || visible) && (
                            <button type="submit" className="deviation-btn" onClick={handleSubmit} disabled={isDisbursed} style={{ marginTop: "20px" }}>
                                {isEditMode ? 'Update' : 'Submit'}
                            </button>
                        )}
                    </div>
                )}
                <ToastContainer />
                <PreviewModal open={previewModal} onClose={handleClosePreview} fileSrc={base64Image} fileType={docType} />
                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={open}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        </div>
    );
};

export default Deviation;
